import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../Widgets.scss';
import './NotificationsWidget.scss';
import Dropdown from 'react-dropdown';
import iconSvg from '../../assets/img/svgLib/iconsSvg';
import {FormControl} from "react-bootstrap";
import Notice from '../../shared/Notice/Notice';
import NoticeInfo from "../../shared/Notice/NoticeInfo";

class NotificationsWidget extends Component {
    static propTypes = {
        userInfo: PropTypes.object,
        classPrefix: PropTypes.string,
    }
    constructor(props) {
        super(props)

        this.pageSetting = {
            title: 'Уведомления'
        };

        this.state = {
            noticeStatuses: [
                {value: 'all', label: 'Все'},
                {value: 'read', label: 'Прочитанные'},
                {value: 'new', label: 'Актуальные'},
            ],
            activeCard: null,
            activeStatuses: 'all',
            showDropDown: true,
            searcherValue: '',
            noticeTemp: [
                {
                id: 1,
                title: 'КП отклонено',
                fullTitle: 'Коммерческое предложение отклонено',
                roleFrom: 'vendor',
                viewStatus: 'new',
                nameCompany: 'РН Уват-Нефтегаз ООО',
                logo: 'rn',
                date: '2018-10-07 15:48:48',
                status: 'alarm',
                data: {
                    id: 38,
                    datePlace: "04.10.18",
                    name: 'Инженерно-геологические и гидрологические изыскания',
                    classificator: "Инженерно-геологические и гидрологические изыскания",
                    dateCompleted: "2018-10-07 15:48:48",
                    dealNumber: 'ДП-11/1231',
                    factor: {
                        id: 12,
                        name: 'ПАО Альфа-Банк',
                        logo: '',
                    },
                    autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
                        deal: {doc: 'Договор', val: true},
                        supplyFact: {doc: 'Подтверждение факта поставки', val: true},
                        sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
                    },
                    debtor: {
                        id: 12,
                        name: 'РН Уват-Нефтегаз ООО',
                        logo: 'rn',
                    },
                    debtorCredit: 0,
                    delay: 210,
                    delayLeft: 100,
                    amount: 43909644,
                    nameCompany: 'Оренбург нефтепродукт ООО',
                    companyGroup: "Газпром",
                    verification: 1,
                    basket: false,
                },
            }, {
                id: 2,
                title: 'КП принят',
                fullTitle: 'Коммерческое предложение Принято',
                roleFrom: 'factor',
                viewStatus: 'read',
                nameCompany: 'Газпром добыча Уренгой ООО',
                logo: 'gaz',
                date: '2018-12-10 15:48:48',
                status: 'ok',
                data: {
                    id: 38,
                    datePlace: "04.10.18",
                    name: 'Инженерно-геологические и гидрологические изыскания',
                    classificator: "Инженерно-геологические и гидрологические изыскания",
                    dateCompleted: "2018-10-07 15:48:48",
                    dealNumber: 'ДП-11/1231',
                    factor: {
                        id: 12,
                        name: 'ПАО Альфа-Банк',
                        logo: '',
                    },
                    autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
                        deal: {doc: 'Договор', val: true},
                        supplyFact: {doc: 'Подтверждение факта поставки', val: true},
                        sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
                    },
                    debtor: {
                        id: 12,
                        name: 'РН Уват-Нефтегаз ООО',
                        logo: '',
                    },
                    debtorCredit: 0,
                    delay: 210,
                    delayLeft: 100,
                    amount: 43909644,
                    nameCompany: 'Оренбург нефтепродукт ООО',
                    companyGroup: "Газпром",
                    verification: 1,
                    basket: false,
                },
            }, {
                id: 3,
                title: 'Взаимные расчеты ',
                fullTitle: 'В рамках данной поставки имеются взаимные расчты сторон',
                roleFrom: 'debtor',
                viewStatus: 'new',
                nameCompany: 'Газпром добыча Уренгой ООО',
                logo: 'gaz',
                date: '2018-10-08 15:48:48',
                status: 'process',
                data: {
                    id: 38,
                    datePlace: "04.10.18",
                    name: 'Инженерно-геологические и гидрологические изыскания',
                    classificator: "Инженерно-геологические и гидрологические изыскания",
                    dateCompleted: "2018-10-07 15:48:48",
                    dealNumber: 'ДП-11/1231',
                    factor: {
                        id: 12,
                        name: 'ПАО Альфа-Банк',
                        logo: '',
                    },
                    autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
                        deal: {doc: 'Договор', val: true},
                        supplyFact: {doc: 'Подтверждение факта поставки', val: true},
                        sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
                    },
                    debtor: {
                        id: 12,
                        name: 'РН Уват-Нефтегаз ООО',
                        logo: '',
                    },
                    debtorCredit: 0,
                    delay: 210,
                    delayLeft: 100,
                    amount: 43909644,
                    nameCompany: 'Оренбург нефтепродукт ООО',
                    companyGroup: "Газпром",
                    verification: 1,
                    basket: false,
                },
            }, {
                id: 4,
                title: 'Рекомендации финансирования',
                fullTitle: 'Реккомендации по финансированию поставки от Дебитора',
                roleFrom: 'factor',
                viewStatus: 'new',
                nameCompany: 'Оренбург нефтепродукт ООО',
                logo: 'gaz',
                date: '2018-10-10 15:48:48',
                status: 'ok',
                data: {
                    id: 38,
                    datePlace: "04.10.18",
                    name: 'Инженерно-геологические и гидрологические изыскания',
                    classificator: "Инженерно-геологические и гидрологические изыскания",
                    dateCompleted: "2018-10-07 15:48:48",
                    dealNumber: 'ДП-11/1231',
                    factor: {
                        id: 12,
                        name: 'ПАО Альфа-Банк',
                        logo: '',
                    },
                    autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
                        deal: {doc: 'Договор', val: true},
                        supplyFact: {doc: 'Подтверждение факта поставки', val: true},
                        sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
                    },
                    debtor: {
                        id: 12,
                        name: 'РН Уват-Нефтегаз ООО',
                        logo: '',
                    },
                    debtorCredit: 0,
                    delay: 210,
                    delayLeft: 100,
                    amount: 43909644,
                    nameCompany: 'Оренбург нефтепродукт ООО',
                    companyGroup: "Газпром",
                    verification: 1,
                    basket: false,
                },
            }, {
                id: 5,
                title: 'Смена реквизитов',
                fullTitle: 'Оплата по поставке должна быть произведена по новым банковским реквизитам',
                roleFrom: 'vendor',
                viewStatus: 'read',
                nameCompany: 'Оренбург нефтепродукт ООО',
                logo: 'gaz',
                date: '2018-10-20 15:48:48',
                status: 'process',
                data: {
                    id: 38,
                    datePlace: "04.10.18",
                    name: 'Инженерно-геологические и гидрологические изыскания',
                    classificator: "Инженерно-геологические и гидрологические изыскания",
                    dateCompleted: "2018-10-07 15:48:48",
                    dealNumber: 'ДП-11/1231',
                    factor: {
                        id: 12,
                        name: 'ПАО Альфа-Банк',
                        logo: '',
                    },
                    autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
                        deal: {doc: 'Договор', val: true},
                        supplyFact: {doc: 'Подтверждение факта поставки', val: true},
                        sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
                    },
                    debtor: {
                        id: 12,
                        name: 'РН Уват-Нефтегаз ООО',
                        logo: '',
                    },
                    debtorCredit: 0,
                    delay: 210,
                    delayLeft: 100,
                    amount: 43909644,
                    nameCompany: 'Оренбург нефтепродукт ООО',
                    companyGroup: "Газпром",
                    verification: 1,
                    basket: false,
                },
            }, {
                id: 6,
                title: 'Новая поставка',
                fullTitle: 'Новая поставка из раздела ваших подписок появилась на площадке',
                roleFrom: 'vendor',
                viewStatus: 'new',
                nameCompany: 'Газпром добыча Уренгой ООО',
                logo: 'gaz',
                date: '2018-10-15 15:48:48',
                status: 'alarm',
                data: {
                    id: 38,
                    datePlace: "04.10.18",
                    name: 'Инженерно-геологические и гидрологические изыскания',
                    classificator: "Инженерно-геологические и гидрологические изыскания",
                    dateCompleted: "2018-10-07 15:48:48",
                    dealNumber: 'ДП-11/1231',
                    factor: {
                        id: 12,
                        name: 'ПАО Альфа-Банк',
                        logo: '',
                    },
                    autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
                        deal: {doc: 'Договор', val: true},
                        supplyFact: {doc: 'Подтверждение факта поставки', val: true},
                        sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
                    },
                    debtor: {
                        id: 12,
                        name: 'РН Уват-Нефтегаз ООО',
                        logo: '',
                    },
                    debtorCredit: 0,
                    delay: 210,
                    delayLeft: 100,
                    amount: 43909644,
                    nameCompany: 'Оренбург нефтепродукт ООО',
                    companyGroup: "Газпром",
                    verification: 1,
                    basket: false,
                },
            }
            ]
        }

    }

    handleActiveCard = (index) => { //TODO Изменение статсуа Уведомления - бэк запрос на апдейт записи
        const {noticeTemp} = this.state;
        const elem = noticeTemp[index];
        elem.viewStatus = 'read';
        noticeTemp.splice(index, 1, elem);
        this.setState({
            activeCard: index,
        })
    }

    handleSearcher = e => {
        this.setState({
            searcherValue: e.target.value,
        })
    }

    handleDropDownStatuses = (e) => {
        this.setState({
            activeStatuses: e.value,
        })
    }

    toggleSearchMode = (event) => {
        this.setState({
            showDropDown: event
        })
    }

    get statusDropDown() {
        const {noticeStatuses, activeStatuses} = this.state;
        return (
            <div className={'dropDownStatuses'}>
                <Dropdown
                    options={noticeStatuses}
                    value={activeStatuses}
                    menuClassName={'dropDownMenu'}
                    arrowClassName={'arrowDropMenu'}
                    onChange={this.handleDropDownStatuses} />
            </div>
            )
    }

    get searcherBlock() {
        const {searcherValue, showDropDown} = this.state;
        return (
            <div className={'searcher'}>
                {showDropDown ? (
                    <div
                        className={'searcherTxt'}
                        onClick={() => this.toggleSearchMode(false)}>
                        <span className={'txt'}>Поиск</span>
                        <span>{iconSvg.search}</span>
                    </div>
                ) : (
                    <div className={'searcherInput'}>
                        <FormControl
                            type={'text'}
                            value={searcherValue}
                            placeholder={'Что будем искать?'}
                            onChange={this.handleSearcher}
                        />
                        <span className={'search'}>{iconSvg.search}</span>
                        <span
                            className={'close'}
                            onClick={() => this.toggleSearchMode(true)}>
                            {iconSvg.close}
                            </span>
                    </div>
                    )
                }
            </div>
        )
    }

    get noticeList() {
        const {noticeTemp, activeCard, activeStatuses} = this.state;

        return (
            <div className={'noticeList'}>
                {noticeTemp.map((item, i) => {
                    return activeStatuses === 'all' ||
                    activeStatuses === item.viewStatus ?
                        (                    <div key={`notice_${i}`}>
                            <Notice idx={i}
                                    notice={item}
                                    active={activeCard === i}
                                    handle={this.handleActiveCard}/>
                        </div>) : null
                })}
            </div>
        )
    }

    render() {
        const {statusDropDown, searcherBlock, noticeList} = this;
        const {classPrefix} = this.props;
        const {showDropDown, activeCard, noticeTemp} = this.state;
        const {title} = this.pageSetting;

        return (<div className={`contentBody${classPrefix}`}>
            <div className={'widgetTitle'}>
                {title}
            </div>
            <div className={'notificationContent'}>
                <div className={'helpersBlock'}>
                    {showDropDown ? statusDropDown : null}
                    {searcherBlock}
                </div>
                {noticeList}
                <NoticeInfo noticeData={noticeTemp[activeCard]}/>
            </div>

        </div>)
    }
}

export default NotificationsWidget




// WEBPACK FOOTER //
// ./src/Widget/NotificationsWidget/NotificationsWidget.js